import CustomButton from "@/components/common/Button";
import { DynamicModuleService } from "@/services/APIs";
import { ProColumns } from "@ant-design/pro-components";
import { Popconfirm } from "antd";
import { Edit2, Trash, FileText } from "lucide-react";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import ConfigDynamicTable from "../../../../components/BaseTable/ConfigDynamicTable";
import MMNavigationRoutes from "../../utils/navigationRoutes";
import { Button } from "@/projects/Civi_Circle_Admin/components/ui/button";

const SOPLibraryList = () => {
  const navigate = useNavigate();
  const schemaName = "SOP";
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);

  const handleDelete = async (id: string) => {
    await DynamicModuleService.deleteItem(schemaName || "", id);
  };

  const handleEdit = (id: string) => {
    navigate("/mm" + MMNavigationRoutes.EDIT_SOP(id));
  };

  const columns: ProColumns<any>[] = [
    {
      title: "Title",
      dataIndex: "title",
      render: (_text: any, record) => {
        return (
          <Link to={`/mm${MMNavigationRoutes.EDIT_SOP(record.id)}`}>
            {record.title}
          </Link>
        );
      },
    },
    {
      title: "Category",
      dataIndex: "category",
    },
    {
      title: "Version Type",
      dataIndex: "versiontype",
    },
    {
      title: "Tags",
      dataIndex: "tags",
    },
    {
      title: "ID",
      dataIndex: "id",
      hidden: true,
    },

    {
      title: "Actions",
      width: 100,
      valueType: "option",
      render: (_, record) => [
        <CustomButton
          key="edit"
          icon={<Edit2 size={16} />}
          onClick={() => handleEdit(record.id)}
          type="text"
        />,
        <Popconfirm
          title="Are you sure you want to delete this SOP?"
          onConfirm={() => handleDelete(record.id)}
          okText="Yes"
          key="delete"
          cancelText="No"
        >
          <CustomButton
            danger
            key="delete"
            icon={<Trash size={16} />}
            type="text"
          />
        </Popconfirm>,
      ],
    },
  ];

  return (
    <div className="space-y-6">
      {/* Header Section */}
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">SOP Library</h1>
          <p className="mt-2 text-muted-foreground">
            Standard Operating Procedures for municipal operations
          </p>
        </div>
        <Button
          onClick={() => navigate("/mm" + MMNavigationRoutes.CREATE_SOP)}
          size="lg"
          className="shadow-lg"
        >
          <FileText className="mr-2 h-4 w-4" />
          Upload SOP
        </Button>
      </div>

      {/* Table Section - Keep existing table logic */}
      <div>
        <ConfigDynamicTable<any>
          columns={columns}
          selectedRowKeys={selectedRowKeys}
          setSelectedRowKeys={setSelectedRowKeys}
          rowKey="id"
          toolBarRender={() => []}
          headerTitle={`SOP Library`}
          tableName={schemaName || ""}
          filter={
            {
              // status__like: "ACTIVE",
            }
          }
        />
      </div>
    </div>
  );
};

export default SOPLibraryList;
